export default defineNuxtRouteMiddleware((to) => {
  // Normaliza URLs antigas do tipo "/clinux/index" -> rota dinâmica "[system]"
  const path = to.path.replace(/\/+$/, '') // remove trailing slashes
  if (!path.endsWith('/index'))
    return

  const base = path.slice(0, -'/index'.length)

  console.log('redirect-index', base)

  // Preserva query/hash
  return navigateTo(base)
})
